import { requiredString } from 'src/utils/schemas';
import * as Yup from 'yup';

export const onboardingSearchCompanyValidationSchema = Yup.object().shape({ regNum: requiredString });

export const onboardingAddCompanyValidationSchema = Yup.object().shape({
	company: Yup.object().shape({ regNum: requiredString, tradingName: requiredString, legalName: requiredString }),
});
